
import BotSocialPlatformsListCard from '@/components/bot/BotSocialPlatformsListCard.vue';
import SocialPostingLatestPostsCard from '@/components/social/SocialPostingLatestPostsCard.vue';
import { ProjectViewMixin } from '@/mixins/ProjectViewMixin';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'project-integration-social-posting',
  components: { BotSocialPlatformsListCard, SocialPostingLatestPostsCard },
})
export default class ProjectIntegrationSocialPosting extends mixins(ProjectViewMixin) {}
